import { CheckCircle2, HelpCircle, Upload, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function ScanPreview({ rows, onOverride, onUpload, onCancel }) {
  const matched = rows.filter((r) => r.customer_name).length;
  return (
    <div className="mt-4 border rounded-lg bg-card" data-testid="scan-preview">
      <div className="px-4 py-3 flex flex-wrap items-center gap-3 border-b">
        <p className="text-sm" data-testid="scan-preview-summary"><span className="font-bold text-emerald-400">{matched}</span> of {rows.length} will be filed · <span className="text-amber-400">{rows.length - matched}</span> to Unsorted</p>
        <p className="text-xs text-muted-foreground">Fix a name on your computer and choose again, or type the invoice # here.</p>
        <div className="ml-auto flex gap-2">
          <Button size="sm" variant="ghost" onClick={onCancel} data-testid="scan-preview-cancel"><X size={14} /> Cancel</Button>
          <Button size="sm" onClick={onUpload} data-testid="scan-preview-upload" className="hover:bg-blue-600 hover:text-white"><Upload size={14} /> Upload {rows.length} scan{rows.length === 1 ? "" : "s"}</Button>
        </div>
      </div>
      <div className="divide-y max-h-80 overflow-y-auto text-sm">
        {rows.map((r, i) => (
          <div key={i} className="px-4 py-2 grid grid-cols-[16px_minmax(0,1fr)_150px_minmax(0,1fr)] items-center gap-3" data-testid={`scan-preview-row-${i}`}>
            {r.customer_name ? <CheckCircle2 size={15} className="text-emerald-400" /> : <HelpCircle size={15} className="text-amber-400" />}
            <span className="font-mono truncate" title={r.name}>{r.name}</span>
            <Input defaultValue={r.override || ""} placeholder={r.invoice_number || "Invoice #"} className="h-8 text-xs font-mono"
              onBlur={(e) => e.target.value.trim() !== (r.override || "") && onOverride(i, e.target.value.trim())} data-testid={`scan-preview-invoice-${i}`} />
            <span className={`truncate text-xs ${r.customer_name ? "" : "text-amber-400"}`} data-testid={`scan-preview-customer-${i}`}>
              {r.customer_name ? `→ ${r.customer_name}` : "Unsorted — no invoice or name match"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
